import { useState } from "react"
import { FormContainerAdminSignUp, FormTitle, Label, StyledInput, InputDiv, FormInfo, Details, FormLink, FormSpan, Flex, GridDiv } from "../../../reusable_ui/styles/Forms.styled"
import { WaveTop, WaveBottom } from "../../../../assets/svg/Form/FormSvg"
import { AdminLoginFormControl } from "./styles/Login.admin.styled"
import { LogoImg } from "../../NavPage/styles/NavPage.styled"
import { InputButton, Check } from "../../../reusable_ui/styles/Button.styled"


const AdminLogin = () => {
  const [id, setId] = useState('')
  const [check, setCheck] = useState(true)

  const CheckState = check ? 'check' : '';

  const onCheck = () => {
    setId(CheckState)
    setCheck(!check)
  }
  return (
    <FormContainerAdminSignUp>
      <WaveTop />
      <WaveBottom />
      <GridDiv>
        <LogoImg />
        <AdminLoginFormControl>
        <FormTitle>
            <span>Sign in</span>
            <p>Sign in to get started with Hydrocis</p>
          </FormTitle>
          <InputDiv>
            <Label>Email address</Label>
            <StyledInput type='email' />
          </InputDiv>
          <InputDiv>
            <Label>Password</Label>
            <StyledInput type='password' />
          </InputDiv>
          <Flex><Check onCheck = {onCheck} id = {id} /> <FormSpan>Remember me</FormSpan></Flex> 
          <InputButton login>Sign in</InputButton>
          <FormInfo>
            <Details><FormLink to=''>Forgot password?</FormLink></Details>
          </FormInfo>
          <FormInfo>
            <Details>Dont have an account? <FormLink to='/user/sign_up'>Sign Up</FormLink></Details>         
          </FormInfo>
        </AdminLoginFormControl>
      </GridDiv>
    </FormContainerAdminSignUp> 
  )
}

export default AdminLogin